import moment, { Moment } from 'moment';
import { useState } from 'react';
import { IResponseDataBody } from 'services/response';
import appointmentApis from 'features/appointment/services/apis';
type IInquiryCustomerHandler = {
  onStart?: (params: { startTime: string, endTime: string, staffId?: string }) => void;
  onDone?: (data: Moment[]) => void;
};
const useInquiryDayOffsWithStaff = (handler?: IInquiryCustomerHandler): [({
  data: Moment[];
}), (params: { startTime: string, endTime: string, staffId: string }) => Promise<void>] => {
  const [timeSlots, setTimeSlots] = useState<Moment[]>([]);
  const _debounce = async (params: { startTime: string, endTime: string, staffId: string }) => {
    handler?.onStart?.(params);
    try {
      const res: IResponseDataBody<string[]> = await appointmentApis.shopOffDay(params.startTime, params.endTime, params.staffId);
      const resData = res?.data?.data;
      if (resData) {
        const data = resData.map(o => moment(o, 'MM-DD-YYYY'));
        setTimeSlots(data);
        handler?.onDone?.(data);
      } else {
        handler?.onDone?.([]);
      }
    } catch (error) {
      handler?.onDone?.([]);
    } finally {
    }
  };

  return [{ data: timeSlots }, _debounce];
};

export default useInquiryDayOffsWithStaff;
